<div class="back-button-container">
  <a routerLink="/" class="back-button">↩ Back</a>
</div>

<div class="contact-page">
  <div class="contact-spare"></div>
  <div class="contact-card">
    <h1 class="form-title">{{ formTitle }}</h1>
    <form class="contact-form" #contactForm="ngForm" (ngSubmit)="sendEmail(contactForm)">
      <div class="field">
        <input class="input" type="text"name="name" ngModel placeholder="Numele Dvs." required autocomplete="name"/>
      </div>

      <div class="field">
        <input class="input" type="email" name="email" ngModel placeholder="Email-ul Dvs." required autocomplete="email"/>
      </div>

      <div class="field">
        <textarea class="textarea" name="message" ngModel rows="9" placeholder="Mesajul Dvs." required></textarea>
      </div>

      @if (successMessage) {
        <p class="success-message">{{ successMessage }}</p>
      }
      @if (errorMessage) {
        <p class="error-message">{{ errorMessage }}</p>
      }

      <div class="actions">
        <button class="shared-primary-button" type="submit" [disabled]="contactForm.invalid || sending">
          @if (sending) {
            <span class="spinner"></span>
          }
          <span>{{ sending ? 'Se trimite…' : 'Trimte' }}</span>
        </button>
      </div>
    </form>
  </div>
  <div class="contact-spare"></div>
</div>
